'use client';

import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { useLayoutEffect, useRef, useState } from 'react';
import { TBlogModuleTestimonial } from '../../blog/blog.types';

import './BlogArticleModuleTestimonial.scss';

type Props = {
  module: TBlogModuleTestimonial;
  mobile?: boolean;
};

export const BlogArticleModuleTestimonial: React.FC<Props> = ({
  module: { title, pages },
  mobile,
}) => {
  const ref = useRef<null | HTMLDivElement>(null);

  const [innerContentHeight, setInnerContentHeight] = useState<'auto' | number>(
    'auto'
  );

  const [selectedPage, setSelectedPage] = useState(pages[0].item);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const { height } = ref.current.getBoundingClientRect();

    setInnerContentHeight(height);
  }, [selectedPage]);

  return (
    <div
      className={clsx('BlogArticleModuleTestimonial', {
        'BlogArticleModuleTestimonial--mobile': mobile,
        'BlogArticleModuleTestimonial--desktop': !mobile,
      })}
    >
      <Typography variant='body'>{title}</Typography>

      {selectedPage && (
        <div
          className='BlogArticleModuleTestimonial__selected-page-wrapper'

          style={{
            height: innerContentHeight,
          }}
        >
          <div
            className='BlogArticleModuleTestimonial__selected-page'
            style={{
              backgroundColor: selectedPage.backgroundColor,
            }}
            ref={ref}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: `${selectedPage.textContent}`,
              }}
            />

            <Typography
              className='BlogArticleModuleTestimonial__author'
              variant='body'
            >
              {selectedPage.author}
            </Typography>
          </div>
        </div>
      )}

      <div className='BlogArticleModuleTestimonial__pagination'>
        {pages.map(page => (
          <svg
            className={clsx('BlogArticleModuleTestimonial__pagination-item', {
              'BlogArticleModuleTestimonial__pagination-item--selected':
                page.item.modulePageId === selectedPage.modulePageId,
            })}
            key={page.item.modulePageId}
            onClick={() => setSelectedPage(page.item)}
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect width='10' height='10' rx='5' fill='#5C5954' />
          </svg>
        ))}
      </div>
    </div>
  );
};
